import Tooltip from '@/components/modules/Tooltip';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import useColors from '@/contexts/tailwindContext/hooks/useColors';
import { WineDrop } from '@winelidays/wld-tsx-2/elements';
const WinePairing = ({ winePairing, appendTooltipTo = 'parent' }) => {
    const translate = useTranslate();
    const label = translate('dish.drink_suggestion.label');
    const { wine: wineColors } = useColors();
    const tooltipContent = <>
      <div className="flex flex-row justify-center mb-1">
        <WineDrop wineColor={winePairing.color} title={translate(`drink.wine.color.${winePairing.color}`, {
            count: 1
        })} translate={translate} wineColors={wineColors} className=""/>
        <p className="text-sm font-semibold text-gray-400 mb-2">{winePairing.vintage}</p>
      </div>
      <p className="text-sm font-semibold text-gray-500">{winePairing.producer.name}</p>
      <p className="text-xs italic font-normal text-gray-400 mt-3">
        &quot;{winePairing.description}&quot;
      </p>
    </>;
    return <Tooltip content={tooltipContent} className="py-4 px-2" appendTo={appendTooltipTo} interactive>
      <button className="btn btn-ghost-primary -ml-2 !text-xs">{label}</button>
    </Tooltip>;
};
export default WinePairing;
